import * as React from 'react';
import {
  calculateProgress,
  PrimaryActionButtonProps,
  primaryActionButtonProps,
} from './utils';
import * as registrationMachine from '../machines/accountRegistration';
import lang from '../lang';
import {UseMachineType} from '../machines/useAccountRegistrationMachineType';

type Props = {registrationMachine: UseMachineType};

type ScreenProps = Props & {
  lang: typeof lang.emailConfirmed;
  progress: number;
  title: string;
  instructions: string;
  actionButtons: {
    primary: PrimaryActionButtonProps;
  };
};

export type EmailConfirmedScreenType = React.ComponentType<ScreenProps>;

export function EmailConfirmed(
  props: Props & {children: EmailConfirmedScreenType}
) {
  const [
    {
      context: {
        account,
        account: {useResponsibleEmail},
        token,
        navigator: {location},
      },
      matches,
    },
    send,
  ] = props.registrationMachine;

  const text = useResponsibleEmail
    ? {
        title: lang.emailConfirmed.title.useResponsibleEmail,
        instructions: lang.emailConfirmed.instructions.useResponsibleEmail,
      }
    : {
        title: lang.emailConfirmed.title.default,
        instructions: lang.emailConfirmed.instructions.default,
      };

  const onClickNext = () => {
    if (!token) {
      return; // Does this condition really exist?
    }

    send(registrationMachine.RegistrationEvent.CHECK_REGISTRATION_STATUS);
  };

  const progress = calculateProgress({
    draftAccount: account,
    location,
  });

  const actionButtons = {
    primary: primaryActionButtonProps({
      children: lang.emailConfirmed.buttons.primary.title,
      onClick: onClickNext,
      loading: matches({
        [registrationMachine.RegistrationState.emailVerified]:
          registrationMachine.RegistrationState.checkingRegistrationStatus,
      }),
    }),
  };

  const renderProps: ScreenProps = {
    ...text,
    lang: lang.emailConfirmed,
    progress,
    actionButtons,
    registrationMachine: props.registrationMachine,
  };

  const Screen = props.children;
  return <Screen {...renderProps} />;
}
